import { r as e, t } from "./rolldown-runtime-CWhphoD1.js";
import { z as n } from "zod";
//#region ../shared/dist/api.js
var r = n.object({
	code: n.string(),
	message: n.string(),
	details: n.unknown().optional()
});
n.object({
	nextCursor: n.string().nullable(),
	hasNextPage: n.boolean(),
	total: n.number().int().optional()
}), n.object({
	status: n.number().int(),
	data: n.null(),
	pagination: n.null(),
	error: r
}), n.object({
	items: n.array(n.unknown()),
	nextCursor: n.string().nullable(),
	hasNextPage: n.boolean(),
	total: n.number().int().optional()
});
//#endregion
//#region ../shared/dist/auth.js
var i = n.union([n.string(), n.date().transform((e) => e.toISOString())]), a = n.enum([
	"OWNER",
	"ADMIN",
	"MEMBER"
]), o = n.object({
	id: n.string(),
	email: n.string(),
	name: n.string(),
	emailVerified: n.boolean(),
	image: n.string().nullable(),
	role: a,
	isActive: n.boolean(),
	isSystemAdmin: n.boolean(),
	canDownloadBackups: n.boolean().optional(),
	twoFactorEnabled: n.boolean().optional(),
	createdAt: i,
	updatedAt: i
}), s = n.object({
	id: n.string(),
	token: n.string(),
	userId: n.string(),
	expiresAt: i,
	createdAt: i,
	updatedAt: i,
	ipAddress: n.string().nullable().optional(),
	userAgent: n.string().nullable().optional()
});
n.object({
	user: o,
	session: s
});
var c = o.extend({
	tenantId: n.string(),
	tenantSlug: n.string()
});
n.object({
	user: c,
	session: s
});
//#endregion
//#region ../shared/dist/constants.js
var l = "mytrellis.io", u = `mail.${l}`;
`${u}`, `${u}`, `${l}`, `${l}`, `${l}`, `${l}`;
var d = [
	{
		code: "AU",
		label: "Australia",
		dialCode: "+61"
	},
	{
		code: "CA",
		label: "Canada",
		dialCode: "+1"
	},
	{
		code: "DE",
		label: "Germany",
		dialCode: "+49"
	},
	{
		code: "FR",
		label: "France",
		dialCode: "+33"
	},
	{
		code: "GB",
		label: "United Kingdom",
		dialCode: "+44"
	},
	{
		code: "IN",
		label: "India",
		dialCode: "+91"
	},
	{
		code: "JP",
		label: "Japan",
		dialCode: "+81"
	},
	{
		code: "NL",
		label: "Netherlands",
		dialCode: "+31"
	},
	{
		code: "NZ",
		label: "New Zealand",
		dialCode: "+64"
	},
	{
		code: "SG",
		label: "Singapore",
		dialCode: "+65"
	},
	{
		code: "US",
		label: "United States",
		dialCode: "+1"
	}
];
d.filter((e) => e.code === "AU");
var f = /^(?:(?:\+61|0)[\s-]?\d?[\s-]?\(?0?\)?[\s-]?(?:[2-9](?:[\s()-]?\d){7}|[2478](?:[\s()-]?\d){8})|[2-9](?:[\s-]?\d){7})$/, p = /^(?:(?:\d[ -]?){10}\d|\d{2} ?\d{3} ?\d{3} ?\d{3})$/, ee = [
	"Australasia / Pacific",
	"Asia",
	"Europe",
	"Africa",
	"Americas",
	"Atlantic / Other"
], te = {
	Africa: "Africa",
	America: "Americas",
	Antarctica: "Australasia / Pacific",
	Arctic: "Atlantic / Other",
	Asia: "Asia",
	Atlantic: "Atlantic / Other",
	Australia: "Australasia / Pacific",
	Europe: "Europe",
	Indian: "Atlantic / Other",
	Pacific: "Australasia / Pacific"
}, ne = {
	"Australia/Sydney": "Australia",
	"Australia/Melbourne": "Australia",
	"Australia/Brisbane": "Australia",
	"Australia/Perth": "Australia",
	"Australia/Adelaide": "Australia",
	"Australia/Darwin": "Australia",
	"Australia/Hobart": "Australia",
	"Australia/Lord_Howe": "Australia",
	"Pacific/Auckland": "New Zealand",
	"Pacific/Fiji": "Fiji",
	"Pacific/Guam": "Guam",
	"Pacific/Honolulu": "United States",
	"Pacific/Tahiti": "French Polynesia",
	"Pacific/Tongatapu": "Tonga",
	"Pacific/Apia": "Samoa",
	"Pacific/Noumea": "New Caledonia",
	"Pacific/Port_Moresby": "Papua New Guinea",
	"Pacific/Chatham": "New Zealand",
	"Asia/Tokyo": "Japan",
	"Asia/Shanghai": "China",
	"Asia/Singapore": "Singapore",
	"Asia/Hong_Kong": "Hong Kong",
	"Asia/Seoul": "South Korea",
	"Asia/Kolkata": "India",
	"Asia/Dubai": "UAE",
	"Asia/Bangkok": "Thailand",
	"Asia/Jakarta": "Indonesia",
	"Asia/Kuala_Lumpur": "Malaysia",
	"Asia/Manila": "Philippines",
	"Asia/Taipei": "Taiwan",
	"Asia/Karachi": "Pakistan",
	"Asia/Dhaka": "Bangladesh",
	"Asia/Colombo": "Sri Lanka",
	"Asia/Kathmandu": "Nepal",
	"Asia/Tashkent": "Uzbekistan",
	"Asia/Almaty": "Kazakhstan",
	"Asia/Tehran": "Iran",
	"Asia/Baghdad": "Iraq",
	"Asia/Riyadh": "Saudi Arabia",
	"Asia/Beirut": "Lebanon",
	"Asia/Amman": "Jordan",
	"Asia/Jerusalem": "Israel",
	"Asia/Nicosia": "Cyprus",
	"Asia/Baku": "Azerbaijan",
	"Asia/Tbilisi": "Georgia",
	"Asia/Yerevan": "Armenia",
	"Europe/London": "United Kingdom",
	"Europe/Paris": "France",
	"Europe/Berlin": "Germany",
	"Europe/Rome": "Italy",
	"Europe/Madrid": "Spain",
	"Europe/Amsterdam": "Netherlands",
	"Europe/Brussels": "Belgium",
	"Europe/Zurich": "Switzerland",
	"Europe/Vienna": "Austria",
	"Europe/Prague": "Czech Republic",
	"Europe/Warsaw": "Poland",
	"Europe/Budapest": "Hungary",
	"Europe/Bucharest": "Romania",
	"Europe/Sofia": "Bulgaria",
	"Europe/Athens": "Greece",
	"Europe/Helsinki": "Finland",
	"Europe/Stockholm": "Sweden",
	"Europe/Oslo": "Norway",
	"Europe/Copenhagen": "Denmark",
	"Europe/Dublin": "Ireland",
	"Europe/Lisbon": "Portugal",
	"Europe/Kyiv": "Ukraine",
	"Europe/Moscow": "Russia",
	"Europe/Istanbul": "Turkey",
	"America/New_York": "United States",
	"America/Los_Angeles": "United States",
	"America/Chicago": "United States",
	"America/Denver": "United States",
	"America/Phoenix": "United States",
	"America/Toronto": "Canada",
	"America/Vancouver": "Canada",
	"America/Sao_Paulo": "Brazil",
	"America/Buenos_Aires": "Argentina",
	"America/Mexico_City": "Mexico",
	"America/Bogota": "Colombia",
	"America/Lima": "Peru",
	"America/Santiago": "Chile",
	"America/Caracas": "Venezuela",
	"America/Havana": "Cuba",
	"America/Jamaica": "Jamaica",
	"Atlantic/Reykjavik": "Iceland",
	"Atlantic/Azores": "Portugal"
}, re = [
	"UTC",
	"Australia/Sydney",
	"Australia/Melbourne",
	"Australia/Brisbane",
	"Australia/Perth",
	"Australia/Adelaide",
	"Pacific/Auckland",
	"Asia/Tokyo",
	"Asia/Singapore",
	"Europe/London",
	"Europe/Paris",
	"America/New_York",
	"America/Los_Angeles"
], m = (e) => e === "" ? void 0 : e, h = n.string().optional().transform(m).pipe(n.string().optional()), g = n.string().trim().transform(m).pipe(n.email().optional()), _ = n.string().optional().transform(m).pipe(n.string().max(50).regex(f, "Must be a valid Australian phone number").optional());
n.string().transform(m).pipe(n.string().max(50).regex(f, "Must be a valid Australian phone number").optional()), n.string().optional().transform(m).pipe(n.string().regex(p, "Must be a valid ABN (e.g. 12 345 678 901)").optional()), n.string().transform(m).pipe(n.string().regex(p, "Must be a valid ABN (e.g. 12 345 678 901)").optional());
function v(e) {
	return !e || e.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, "").replace(/\u00A0/g, "").trim().length === 0;
}
//#endregion
//#region ../shared/dist/clients.js
var y = n.enum([
	"ACTIVE",
	"INACTIVE",
	"PROSPECT"
]), b = n.object({
	fullName: n.string().min(1).max(255),
	email: g.optional(),
	phone: _,
	notes: h,
	position: n.string().optional().transform(m).pipe(n.string().max(255).optional())
});
b.partial(), n.object({
	name: n.string().min(1).max(255),
	email: g.optional(),
	phone: _,
	company: n.string().optional().transform(m).pipe(n.string().max(255).optional()),
	address: h,
	notes: h,
	status: y.default("ACTIVE"),
	contacts: n.array(b).optional()
}).extend({ status: y }).partial();
//#endregion
//#region ../shared/dist/document-discount.js
var x = n.enum([
	"NONE",
	"PERCENTAGE",
	"FIXED"
]);
function S(e) {
	return e.discountType !== "PERCENTAGE" || (e.discount ?? 0) <= 100;
}
var C = {
	error: "Discount percentage cannot exceed 100%",
	path: ["discount"]
}, ie = n.enum([
	"sm",
	"md",
	"lg",
	"xl",
	"print"
]), w = n.partialRecord(ie, n.string());
(/* @__PURE__ */ t(((t, n) => {
	(function(r, i) {
		/* istanbul ignore else */
		typeof e == "function" && typeof t == "object" && typeof n == "object" ? n.exports = i() : typeof define == "function" && define.amd ? define(function() {
			return i();
		}) : r.pluralize = i();
	})(t, function() {
		var e = [], t = [], n = {}, r = {}, i = {};
		function a(e) {
			return typeof e == "string" ? RegExp("^" + e + "$", "i") : e;
		}
		function o(e, t) {
			return e === t ? t : e === e.toLowerCase() ? t.toLowerCase() : e === e.toUpperCase() ? t.toUpperCase() : e[0] === e[0].toUpperCase() ? t.charAt(0).toUpperCase() + t.substr(1).toLowerCase() : t.toLowerCase();
		}
		function s(e, t) {
			return e.replace(/\$(\d{1,2})/g, function(e, n) {
				return t[n] || "";
			});
		}
		function c(e, t) {
			return e.replace(t[0], function(n, r) {
				var i = s(t[1], arguments);
				return o(n === "" ? e[r - 1] : n, i);
			});
		}
		function l(e, t, r) {
			if (!e.length || n.hasOwnProperty(e)) return t;
			for (var i = r.length; i--;) {
				var a = r[i];
				if (a[0].test(t)) return c(t, a);
			}
			return t;
		}
		function u(e, t, n) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? o(r, i) : e.hasOwnProperty(i) ? o(r, e[i]) : l(i, r, n);
			};
		}
		function d(e, t, n, r) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? !0 : !e.hasOwnProperty(i) && l(i, i, n) === i;
			};
		}
		function f(e, t, n) {
			var r = t === 1 ? f.singular(e) : f.plural(e);
			return (n ? t + " " : "") + r;
		}
		return f.plural = u(i, r, e), f.isPlural = d(i, r, e), f.singular = u(r, i, t), f.isSingular = d(r, i, t), f.addPluralRule = function(t, n) {
			e.push([a(t), n]);
		}, f.addSingularRule = function(e, n) {
			t.push([a(e), n]);
		}, f.addUncountableRule = function(e) {
			if (typeof e == "string") {
				n[e.toLowerCase()] = !0;
				return;
			}
			f.addPluralRule(e, "$0"), f.addSingularRule(e, "$0");
		}, f.addIrregularRule = function(e, t) {
			t = t.toLowerCase(), e = e.toLowerCase(), i[e] = t, r[t] = e;
		}, [
			["I", "we"],
			["me", "us"],
			["he", "they"],
			["she", "they"],
			["them", "them"],
			["myself", "ourselves"],
			["yourself", "yourselves"],
			["itself", "themselves"],
			["herself", "themselves"],
			["himself", "themselves"],
			["themself", "themselves"],
			["is", "are"],
			["was", "were"],
			["has", "have"],
			["this", "these"],
			["that", "those"],
			["echo", "echoes"],
			["dingo", "dingoes"],
			["volcano", "volcanoes"],
			["tornado", "tornadoes"],
			["torpedo", "torpedoes"],
			["genus", "genera"],
			["viscus", "viscera"],
			["stigma", "stigmata"],
			["stoma", "stomata"],
			["dogma", "dogmata"],
			["lemma", "lemmata"],
			["schema", "schemata"],
			["anathema", "anathemata"],
			["ox", "oxen"],
			["axe", "axes"],
			["die", "dice"],
			["yes", "yeses"],
			["foot", "feet"],
			["eave", "eaves"],
			["goose", "geese"],
			["tooth", "teeth"],
			["quiz", "quizzes"],
			["human", "humans"],
			["proof", "proofs"],
			["carve", "carves"],
			["valve", "valves"],
			["looey", "looies"],
			["thief", "thieves"],
			["groove", "grooves"],
			["pickaxe", "pickaxes"],
			["passerby", "passersby"]
		].forEach(function(e) {
			return f.addIrregularRule(e[0], e[1]);
		}), [
			[/s?$/i, "s"],
			[/[^\u0000-\u007F]$/i, "$0"],
			[/([^aeiou]ese)$/i, "$1"],
			[/(ax|test)is$/i, "$1es"],
			[/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
			[/(e[mn]u)s?$/i, "$1s"],
			[/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
			[/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
			[/(seraph|cherub)(?:im)?$/i, "$1im"],
			[/(her|at|gr)o$/i, "$1oes"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
			[/sis$/i, "ses"],
			[/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
			[/([^aeiouy]|qu)y$/i, "$1ies"],
			[/([^ch][ieo][ln])ey$/i, "$1ies"],
			[/(x|ch|ss|sh|zz)$/i, "$1es"],
			[/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
			[/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
			[/(pe)(?:rson|ople)$/i, "$1ople"],
			[/(child)(?:ren)?$/i, "$1ren"],
			[/eaux$/i, "$0"],
			[/m[ae]n$/i, "men"],
			["thou", "you"]
		].forEach(function(e) {
			return f.addPluralRule(e[0], e[1]);
		}), [
			[/s$/i, ""],
			[/(ss)$/i, "$1"],
			[/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
			[/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
			[/ies$/i, "y"],
			[/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
			[/\b(mon|smil)ies$/i, "$1ey"],
			[/\b((?:tit)?m|l)ice$/i, "$1ouse"],
			[/(seraph|cherub)im$/i, "$1"],
			[/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
			[/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
			[/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
			[/(test)(?:is|es)$/i, "$1is"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
			[/(alumn|alg|vertebr)ae$/i, "$1a"],
			[/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
			[/(matr|append)ices$/i, "$1ix"],
			[/(pe)(rson|ople)$/i, "$1rson"],
			[/(child)ren$/i, "$1"],
			[/(eau)x?$/i, "$1"],
			[/men$/i, "man"]
		].forEach(function(e) {
			return f.addSingularRule(e[0], e[1]);
		}), [
			"adulthood",
			"advice",
			"agenda",
			"aid",
			"aircraft",
			"alcohol",
			"ammo",
			"analytics",
			"anime",
			"athletics",
			"audio",
			"bison",
			"blood",
			"bream",
			"buffalo",
			"butter",
			"carp",
			"cash",
			"chassis",
			"chess",
			"clothing",
			"cod",
			"commerce",
			"cooperation",
			"corps",
			"debris",
			"diabetes",
			"digestion",
			"elk",
			"energy",
			"equipment",
			"excretion",
			"expertise",
			"firmware",
			"flounder",
			"fun",
			"gallows",
			"garbage",
			"graffiti",
			"hardware",
			"headquarters",
			"health",
			"herpes",
			"highjinks",
			"homework",
			"housework",
			"information",
			"jeans",
			"justice",
			"kudos",
			"labour",
			"literature",
			"machinery",
			"mackerel",
			"mail",
			"media",
			"mews",
			"moose",
			"music",
			"mud",
			"manga",
			"news",
			"only",
			"personnel",
			"pike",
			"plankton",
			"pliers",
			"police",
			"pollution",
			"premises",
			"rain",
			"research",
			"rice",
			"salmon",
			"scissors",
			"series",
			"sewage",
			"shambles",
			"shrimp",
			"software",
			"species",
			"staff",
			"swine",
			"tennis",
			"traffic",
			"transportation",
			"trout",
			"tuna",
			"wealth",
			"welfare",
			"whiting",
			"wildebeest",
			"wildlife",
			"you",
			/pok[eé]mon$/i,
			/[^aeiou]ese$/i,
			/deer$/i,
			/fish$/i,
			/measles$/i,
			/o[iu]s$/i,
			/pox$/i,
			/sheep$/i
		].forEach(f.addUncountableRule), f;
	});
})))();
var T = n.string().min(1, { error: "Unit type is required" }).max(50, { error: "Unit type must be 50 characters or fewer" }).transform((e) => e.trim().toUpperCase()).pipe(n.string().min(1, { error: "Unit type is required" })), E = n.enum([
	"NONE",
	"PERCENTAGE",
	"FIXED"
]), D = n.object({
	title: n.string().min(1, { error: "Title must contain at least 1 character" }).max(255),
	description: h,
	unitPrice: n.coerce.number({ error: "Unit price must be a number" }).min(0, { error: "Unit price must be greater than or equal to 0" }),
	unitType: T.default("HOUR"),
	quantity: n.coerce.number().positive({ error: "Quantity must be greater than 0" }),
	discount: n.coerce.number().min(0).default(0),
	discountType: E.default("NONE"),
	taxable: n.boolean().default(!0)
});
D.refine(S, C), D.partial().refine(S, C);
//#endregion
//#region ../shared/dist/invoices.js
function O(e) {
	let t = /* @__PURE__ */ new Date(`${e}T00:00:00.000Z`);
	return !Number.isNaN(t.getTime()) && t.toISOString().startsWith(e);
}
var k = n.object({
	lineItemId: n.string().min(1),
	quantity: n.number().positive(),
	discount: n.number().min(0).optional(),
	discountType: E.optional()
}).strict().refine(S, C), A = n.object({
	title: n.string().min(1, { error: "Title is required" }),
	description: n.string().optional(),
	unitPrice: n.number({ error: "A valid unit price is required" }).min(0, { error: "Unit price must be ≥ 0" }),
	quantity: n.number().positive({ error: "Quantity must be positive" }),
	unitType: T,
	discount: n.number().min(0).optional(),
	discountType: E.optional(),
	taxable: n.boolean().optional()
}).refine(S, C), ae = n.union([k, A]);
n.object({ lineItemId: n.string().min(1) }), n.object({
	title: n.string().min(1, { error: "Title must contain at least 1 character" }).max(255).optional(),
	description: n.union([n.string(), n.null()]).optional(),
	unitPrice: n.coerce.number().min(0, { error: "Unit price must be 0 or greater" }).optional(),
	unitType: T.optional(),
	quantity: n.coerce.number().positive({ error: "Quantity must be a positive number" }).optional(),
	discount: n.coerce.number().min(0).optional(),
	discountType: E.optional(),
	taxable: n.boolean().optional()
}).refine(S, C);
var oe = n.object({
	id: n.string().optional(),
	lineItemId: n.string().optional(),
	title: n.string().min(1, { error: "Title is required" }),
	description: n.string().optional(),
	unitPrice: n.coerce.number().min(0, { error: "Unit price must be ≥ 0" }),
	unitType: T,
	quantity: n.coerce.number().positive({ error: "Quantity must be positive" }),
	discount: n.coerce.number().min(0).default(0),
	discountType: E.default("NONE"),
	taxable: n.boolean().default(!0)
}).refine(S, C);
n.object({ lineItems: n.array(oe) }), n.enum([
	"DRAFT",
	"SENT",
	"PAID",
	"OVERDUE",
	"CANCELLED",
	"VOID"
]);
var j = n.enum([
	"NONE",
	"GST",
	"VAT",
	"HST",
	"PST",
	"SALES_TAX",
	"CUSTOM"
]), M = n.enum([
	"NONE",
	"GST",
	"CUSTOM"
]), N = n.object({
	clientId: n.string().min(1, { error: "You must select a client from the list" }),
	invoiceNumber: n.string().trim().min(1, { error: "Invoice number cannot be empty" }).max(50, { error: "Invoice number must be 50 characters or fewer" }).optional(),
	locale: n.literal("en-AU").optional(),
	currency: n.literal("AUD").optional(),
	taxType: M.default("NONE"),
	taxRate: n.coerce.number().min(0, { error: "Tax rate cannot be negative" }).max(1, { error: "Tax rate cannot exceed 100%" }).default(0),
	discount: n.coerce.number().min(0, { error: "Discount cannot be negative" }).default(0),
	discountType: x.default("NONE"),
	notes: n.string().transform((e) => e === "" ? null : e).pipe(n.string().nullable()).default(null),
	terms: n.string().nullable().transform((e) => e === "" ? null : e).default(null),
	issueDate: n.iso.date({ error: "Issue date is required" }).refine((e) => O(e), { error: "Issue date must be a valid calendar date" }).transform((e) => `${e}T00:00:00.000Z`),
	dueAt: n.iso.date({ error: "Due date is required" }).refine((e) => O(e), { error: "Due date must be a valid calendar date" }).transform((e) => `${e}T00:00:00.000Z`),
	remindersEnabled: n.boolean().optional(),
	reminderScheduleId: n.string().min(1).nullable().optional(),
	lineItems: n.array(ae).optional()
});
N.refine(S, C), N.partial().refine(S, C), n.object({ invoiceNumber: n.string().trim().min(1, { error: "Invoice number cannot be empty" }).max(50, { error: "Invoice number must be 50 characters or fewer" }).optional() }), n.object({
	amount: n.number().positive({ error: "Amount must be positive" }),
	currency: n.literal("AUD").optional(),
	paidAt: n.iso.datetime({ error: "Paid date is required" }),
	note: n.string().transform((e) => e === "" ? null : e).pipe(n.string().nullable()).default(null)
}), n.object({
	receiptUrls: w,
	receiptFilename: n.string(),
	receiptMimeType: n.string(),
	receiptSizeBytes: n.number()
}), n.object({ receiptUrls: w }), n.enum(Object.values({
	BUSINESS_DETAILS: "business-details",
	TAX_SETTINGS: "tax-settings",
	BRANDING: "branding",
	PAYMENT_DETAILS: "payment-details",
	GETTING_STARTED: "getting-started",
	TWO_FACTOR_SECURITY: "two-factor-security",
	ONBOARDING_WIZARD: "onboarding-wizard"
}));
//#endregion
//#region ../shared/dist/payments.js
var P = n.string().optional().transform(m).pipe(n.string().optional());
n.enum([
	"BANK_TRANSFER",
	"PAYPAL",
	"STRIPE",
	"CREDIT_CARD",
	"CUSTOM"
]);
var se = n.object({
	type: n.literal("BANK_TRANSFER"),
	isDefault: n.boolean(),
	label: P,
	bsb: n.string().min(6),
	accountNumber: n.string().min(8),
	accountName: n.string().min(1),
	reference: P
}), ce = n.object({
	type: n.literal("PAYPAL"),
	isDefault: n.boolean(),
	label: P,
	email: n.string().transform(m).pipe(n.string().email())
}), le = n.object({
	type: n.literal("STRIPE"),
	isDefault: n.boolean(),
	label: P,
	paymentLink: n.string().transform(m).pipe(n.string().url())
}), ue = n.object({
	type: n.literal("CREDIT_CARD"),
	isDefault: n.boolean(),
	label: P,
	instructions: n.string().min(1)
}), de = n.object({
	type: n.literal("CUSTOM"),
	isDefault: n.boolean(),
	label: n.string().min(1, { error: "Label is required for custom payment methods" }),
	instructions: n.string().min(1)
}), fe = n.discriminatedUnion("type", [
	se,
	ce,
	le,
	ue,
	de
]), F = n.string().optional().transform(m).pipe(n.string().optional());
function pe(e) {
	let t = /* @__PURE__ */ new Date(`${e}T00:00:00.000Z`);
	return !Number.isNaN(t.getTime()) && t.toISOString().startsWith(e);
}
n.object({
	name: F,
	email: n.string({ error: "Email is required" }).trim().min(1, "Email is required").email(),
	phone: _,
	address: F,
	country: n.string().optional().transform(m).pipe(n.literal("AU").optional()),
	timezone: n.string().optional().transform(m).pipe(n.string().refine((e) => Intl.supportedValuesOf("timeZone").includes(e), "Invalid IANA timezone").optional())
});
var me = n.enum([
	"ABN",
	"GST",
	"VAT",
	"EIN",
	"HST",
	"GSTIN",
	"Other"
]);
n.object({
	taxIdType: me.optional(),
	taxIdValue: F,
	taxIdCustomLabel: F,
	defaultTaxType: M.nullable().optional(),
	defaultTaxRate: n.number().min(0).max(1).nullable().optional(),
	gstRegistered: n.boolean().nullable().optional(),
	gstRegisteredFrom: n.iso.date().nullable().optional().refine((e) => e == null || pe(e), { error: "\"Registered since\" must be a valid calendar date" }).transform((e) => e == null ? e : `${e}T00:00:00.000Z`).pipe(n.string().nullable().optional())
}).superRefine((e, t) => {
	e.taxIdType === "Other" && !e.taxIdCustomLabel && t.addIssue({
		code: "custom",
		message: "Custom label is required when Tax ID type is \"Other\"",
		path: ["taxIdCustomLabel"]
	}), e.taxIdType !== "Other" && e.taxIdCustomLabel && t.addIssue({
		code: "custom",
		message: "Custom label is only used when Tax ID type is \"Other\"",
		path: ["taxIdCustomLabel"]
	}), e.taxIdType === "ABN" && e.taxIdValue && !p.test(e.taxIdValue) && t.addIssue({
		code: "custom",
		message: "Must be a valid ABN (e.g. 12 345 678 901)",
		path: ["taxIdValue"]
	}), e.defaultTaxType === "CUSTOM" && (e.defaultTaxRate === void 0 || e.defaultTaxRate === null) && t.addIssue({
		code: "custom",
		message: "Tax rate is required when tax type is Custom",
		path: ["defaultTaxRate"]
	}), e.gstRegistered === !0 && e.defaultTaxType !== void 0 && e.defaultTaxType !== "GST" && t.addIssue({
		code: "custom",
		message: "Default tax type must be GST when registered for GST",
		path: ["defaultTaxType"]
	}), e.gstRegistered !== !0 && e.gstRegisteredFrom && t.addIssue({
		code: "custom",
		message: "\"Registered since\" date is only used when GST registered is Yes",
		path: ["gstRegisteredFrom"]
	});
}), n.object({
	paymentOptions: n.array(fe),
	paymentTermsDays: n.number().int().min(1).max(365)
});
var he = n.string().regex(/^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/, "Must be a valid domain (e.g. acme.com)"), ge = n.union([n.cidrv4(), n.cidrv6()]);
n.object({
	allowedDomains: n.array(he),
	allowedCidrs: n.array(ge)
}), n.object({ invoiceNumberPrefix: n.string().regex(/^[A-Z0-9-]{1,10}$/, "Prefix must be 1-10 characters: A-Z, 0-9, or \"-\"") }), n.object({ nextNumber: n.number().int().positive() }), n.object({ accepted: n.literal(!0) });
var _e = n.object({
	daysRelativeToDue: n.number().int().min(-7, { message: "Reminders can start at most 7 days before the due date." }).max(30, { message: "Reminders can run at most 30 days after the due date." }),
	emailClient: n.boolean(),
	alertStaff: n.boolean()
}).refine((e) => e.emailClient || e.alertStaff, {
	message: "Choose at least one: email the client or alert you.",
	path: ["emailClient"]
}), ve = n.object({
	every: n.number().int().min(1).max(30),
	max: n.number().int().min(1).max(30)
});
function ye(e) {
	let t = e.filter((e) => e.emailClient).map((e) => e.daysRelativeToDue);
	return t.length > 0 ? Math.max(...t) : null;
}
var be = n.array(_e).min(1, { message: "Add at least one reminder." }).max(5, { message: "A schedule can have at most 5 reminders." }).superRefine((e, t) => {
	let n = /* @__PURE__ */ new Set();
	e.forEach((e, r) => {
		n.has(e.daysRelativeToDue) && t.addIssue({
			code: "custom",
			path: [r, "daysRelativeToDue"],
			message: "Another step already uses this day."
		}), n.add(e.daysRelativeToDue);
	});
});
function xe(e, t) {
	if (!e.repeat || !e.steps) return;
	let n = ye(e.steps);
	if (n === null) {
		t.addIssue({
			code: "custom",
			path: ["repeat"],
			message: "Repeating needs at least one reminder that emails the client."
		});
		return;
	}
	let r = n + e.repeat.every * e.repeat.max;
	r > 30 && t.addIssue({
		code: "custom",
		path: ["repeat"],
		message: `Repeats must finish within 30 days after the due date. This one ends on day ${r}. Reduce the interval or the number of repeats.`
	});
}
n.object({
	steps: be,
	repeat: ve.nullable().optional()
}).superRefine(xe), n.object({ status: n.enum(["DISMISSED", "SCHEDULED"]) }), n.enum([
	"BEFORE_DUE",
	"DUE_DATE",
	"OVERDUE"
]);
//#endregion
//#region ../shared/dist/users.js
var Se = n.enum(["ADMIN", "MEMBER"]);
n.object({
	email: n.email(),
	role: Se
}), n.object({ role: a }), n.object({ name: n.string().min(1, "Name is required") }), n.enum(Object.values({
	ONBOARDING_TOUR: "onboarding-tour",
	IP_ALLOWLISTING: "ip-allowlisting",
	MILESTONE_SPLIT_INVOICING: "milestone-split-invoicing",
	TAX_COMPLIANCE_REPORTING: "tax-compliance-reporting",
	TAGS: "tags",
	ACCOUNTING_EXPORT: "accounting-export",
	USER_MANAGEMENT: "user-management",
	STRIPE_PAYMENTS: "stripe-payments",
	USER_FEEDBACK: "user-feedback"
})), n.object({ enabled: n.boolean() });
//#endregion
//#region ../shared/dist/recurrence.js
var I = n.enum([
	"DAILY",
	"WEEKLY",
	"FORTNIGHTLY",
	"MONTHLY",
	"QUARTERLY",
	"ANNUALLY"
]);
n.object({
	frequency: I,
	interval: n.number().int().min(1).default(1),
	daysOfWeek: n.array(n.number().int().min(0).max(6)).default([]),
	dayOfMonth: n.number().int().min(1).max(31).optional(),
	monthOfYear: n.number().int().min(1).max(12).optional()
});
var L = n.enum([
	"never",
	"after_n",
	"on_date"
]), Ce = n.discriminatedUnion("type", [
	n.object({ type: n.literal(L.enum.never) }),
	n.object({
		type: n.literal(L.enum.after_n),
		maxRuns: n.number().int().min(1)
	}),
	n.object({
		type: n.literal(L.enum.on_date),
		endDate: n.string().date()
	})
]), R = n.union([k, A]);
n.object({
	clientId: n.string().min(1, { error: "Client is required" }),
	frequency: I,
	interval: n.number().int().min(1).default(1),
	daysOfWeek: n.array(n.number().int().min(0).max(6)).default([]),
	dayOfMonth: n.number().int().min(1).max(31).optional(),
	monthOfYear: n.number().int().min(1).max(12).optional(),
	endCondition: Ce,
	nextRunAt: n.string().datetime({ message: "nextRunAt must be an ISO datetime string" }),
	locale: n.literal("en-AU").optional(),
	currency: n.literal("AUD").optional(),
	taxType: M.default("NONE"),
	taxRate: n.coerce.number().min(0).max(1).default(0),
	netDays: n.number().int().min(0).default(14),
	notes: n.string().transform((e) => e === "" ? null : e).pipe(n.string().nullable()).default(null),
	autoSend: n.boolean().default(!1),
	remindersEnabled: n.boolean().optional(),
	reminderScheduleId: n.string().min(1).nullable().optional(),
	lineItems: n.array(R).default([])
}).omit({
	clientId: !0,
	lineItems: !0
}).partial();
var we = n.enum([
	"ACTIVE",
	"PAUSED",
	"CANCELLED"
]);
n.object({ status: we });
//#endregion
//#region ../shared/dist/tenants.js
var Te = /* @__PURE__ */ new Set([
	"admin",
	"api",
	"app",
	"auth",
	"billing",
	"blog",
	"cdn",
	"dashboard",
	"docs",
	"help",
	"login",
	"mail",
	"pilot",
	"signup",
	"status",
	"support",
	"system",
	"www"
]);
n.string().min(3).max(63).regex(/^[a-z][a-z0-9-]*[a-z0-9]$/, { message: "Slug must start with a letter, end with a letter or number, and contain only lowercase letters, numbers, and hyphens" }).refine((e) => !Te.has(e), { message: "This slug is reserved and cannot be used" });
var Ee = /* @__PURE__ */ "airy.amber.ancient.balmy.beaming.blooming.bold.breezy.bright.brisk.budding.calm.cheerful.cheery.clever.cosy.crisp.curious.dappled.dazzling.dewy.eager.earthy.elegant.fair.fearless.fertile.fragrant.fresh.friendly.frosty.gentle.gleaming.glossy.golden.graceful.grand.green.happy.hardy.hearty.honest.humble.jolly.joyful.keen.kind.leafy.lively.lofty.lovely.loyal.lucky.lush.mellow.merry.mighty.mild.misty.mossy.nimble.noble.patient.peaceful.perky.pleasant.plucky.polished.proud.quiet.radiant.rooted.rugged.rustling.serene.shady.sheltered.shimmering.showy.silver.sleepy.snug.soft.spirited.splendid.spry.stately.steady.sturdy.sunlit.sunny.supple.swaying.sweet.tall.tender.thriving.torrential.tranquil.trusty.twining.upright.verdant.vibrant.vivid.wandering.warm.whispering.wild.willing.windy.winding.wise.wabisabi.woody.young.zen.zesty".split("."), De = /* @__PURE__ */ "acorn.alder.apple.ash.aspen.azalea.bamboo.banksia.baobab.basil.beech.bluebell.blossom.boronia.bottlebrush.bough.bracken.bramble.branch.brook.bud.buttercup.callistemon.camellia.canopy.cedar.cherry.chestnut.clearing.clematis.clover.creek.cypress.daisy.dell.dill.elm.eucalyptus.fennel.fern.fig.fir.foxglove.frangipani.fuchsia.gardenia.glade.gorse.grevillea.grove.hawthorn.hazel.heather.hemlock.hibiscus.hickory.hollow.holly.honeysuckle.hydrangea.iris.ivy.jacaranda.jasmine.juniper.larch.laurel.lavender.leaf.lichen.lilac.lily.linden.lotus.lupin.kumquat.magnolia.mahogany.maple.momiji.marigold.meadow.mint.moss.mulberry.myrtle.olive.orchid.parsley.peach.pear.pecan.peony.petal.pine.plum.poppy.poplar.primrose.quince.redwood.reed.ridge.root.rosemary.rowan.sage.sakura.sapling.sedge.seedling.sequoia.sorrel.spring.spruce.stream.sycamore.tamarind.teak.tendril.thicket.thistle.thyme.tree.trellis.trunk.tulip.twig.vale.violet.walnut.waratah.wattle.willow.wisteria.yarrow".split(".");
new Set(Ee), new Set(De), n.object({
	name: n.string().min(1).max(50),
	color: n.string().regex(/^#[0-9a-fA-F]{6}$/).optional()
}).partial(), n.object({ tagIds: n.array(n.string().cuid()) });
var z = n.object({
	id: n.string(),
	name: n.string(),
	color: n.string().nullable(),
	createdAt: n.string(),
	updatedAt: n.string()
}), Oe = n.object({
	clients: n.number(),
	invoices: n.number(),
	quotes: n.number(),
	lineItems: n.number(),
	expenses: n.number()
});
z.extend({ usage: Oe });
//#endregion
//#region ../shared/dist/expenses.js
var B = n.enum(["BUSINESS", "REIMBURSEMENT"]), V = n.enum(["DOLLARS", "PERCENTAGE"]), H = n.enum(/* @__PURE__ */ "ADVERTISING.BANK_FEES.COST_OF_GOODS_SOLD.DEPRECIATION.DIVIDENDS_DEDUCTION.DONATIONS.EQUIPMENT_PURCHASE.HEALTH_AND_SAFETY_EQUIPMENT.HOME_OFFICE_EXPENSES_ACTUAL.HOME_OFFICE_EXPENSES_FIXED_RATE.INTERNET.MOBILE_PHONE_BILL.MOTOR_VEHICLE_EXPENSES.MOTOR_VEHICLE_EXPENSES_CENTS_PER_KM.MOTOR_VEHICLE_PURCHASE.PARKING_AND_TRANSPORT.PAYROLL.PRINTING_AND_STATIONERY.PROFESSIONAL_FEES.PROFESSIONAL_INSURANCE.REFUNDS.RENT_EXTERNAL_SPACE_HIRE.REPAIRS_AND_MAINTENANCE_EQUIPMENT.REPAIRS_AND_MAINTENANCE_HOME_OFFICE.RESEARCH_AND_DEVELOPMENT.SUB_CONTRACTOR_FEES.SUBSCRIPTION_FEES.SUPERANNUATION_CONTRIBUTION.TRAVEL_NATIONAL_AND_INTERNATIONAL.UNIFORM".split(".")), U = n.object({
	expenseDate: n.iso.datetime({ error: "Expense date is required" }),
	totalCost: n.coerce.number({ error: "Total cost must be a number" }).min(0, { error: "Total cost must be 0 or greater" }),
	taxIncluded: n.boolean().default(!1),
	taxType: j.default("NONE"),
	taxRate: n.coerce.number().min(0, { error: "Tax rate cannot be negative" }).max(1, { error: "Tax rate cannot exceed 100%" }).default(0),
	claimableAmountType: V,
	claimableAmount: n.coerce.number({ error: "Claimable amount must be a number" }).min(0, { error: "Claimable amount must be 0 or greater" }),
	title: h,
	description: h
}), W = U.extend({
	type: n.literal("BUSINESS"),
	category: H,
	lineItemId: h,
	claimed: n.boolean().optional(),
	tagIds: n.array(n.string()).optional()
}), G = U.extend({
	type: n.literal("REIMBURSEMENT"),
	title: n.string().min(1, { error: "Title is required" }),
	clientId: n.string().min(1, { error: "Client is required" }),
	unitType: T.default("UNIT"),
	quantity: n.coerce.number({ error: "Quantity must be a number" }).positive({ error: "Quantity must be greater than 0" }).default(1),
	tagIds: n.array(n.string()).optional()
});
n.discriminatedUnion("type", [W, G]);
var ke = W.partial().extend({ type: n.literal("BUSINESS") }), Ae = G.partial().extend({ type: n.literal("REIMBURSEMENT") });
n.discriminatedUnion("type", [ke, Ae]), n.object({
	id: n.string(),
	expenseNumber: n.string().nullable(),
	type: B,
	expenseDate: n.iso.datetime(),
	totalCost: n.number(),
	taxIncluded: n.boolean(),
	taxType: j,
	taxRate: n.number(),
	taxAmount: n.number(),
	claimableAmountType: V,
	claimableAmount: n.number(),
	title: n.string().nullable(),
	description: n.string().nullable(),
	category: H.nullable(),
	lineItemId: n.string().nullable(),
	lineItemTitle: n.string().nullable(),
	claimed: n.boolean(),
	clientId: n.string().nullable(),
	clientName: n.string().nullable(),
	unitType: T,
	quantity: n.number(),
	billed: n.boolean(),
	invoiceLineItemId: n.string().nullable(),
	invoiceId: n.string().nullable(),
	recurringExpenseId: n.string().nullable(),
	hasReceipt: n.boolean(),
	receiptMimeType: n.string().nullable(),
	receiptFilename: n.string().nullable(),
	receiptSizeBytes: n.number().nullable(),
	tags: n.array(z),
	createdAt: n.iso.datetime(),
	updatedAt: n.iso.datetime()
}), n.object({
	receiptUrls: w,
	receiptFilename: n.string(),
	receiptMimeType: n.string(),
	receiptSizeBytes: n.number()
}), n.object({ receiptUrls: w }), n.object({ invoiceId: n.string().min(1, { error: "Invoice is required" }) }), n.object({
	type: B.optional(),
	startDate: n.string().optional(),
	endDate: n.string().optional(),
	category: H.optional(),
	clientId: n.string().optional(),
	tagIds: n.preprocess((e) => e === void 0 ? void 0 : Array.isArray(e) ? e : [e], n.array(n.string())).optional(),
	q: n.string().optional(),
	cursor: n.string().optional(),
	limit: n.coerce.number().int().min(1).max(100).default(25)
});
//#endregion
//#region ../shared/dist/recurring-expenses.js
var K = n.enum([
	"ACTIVE",
	"PAUSED",
	"COMPLETED",
	"CANCELLED"
]), je = n.enum([
	"PENDING",
	"RETRYING",
	"SUCCEEDED",
	"FAILED"
]), q = n.object({
	title: n.string().min(1),
	totalCost: n.number().positive(),
	taxIncluded: n.boolean().default(!1),
	taxType: j.default("NONE"),
	taxRate: n.number().min(0).max(1).default(0),
	claimableAmount: n.number().min(0),
	claimableAmountType: V,
	description: n.string().nullable().optional()
}), J = {
	frequency: I,
	interval: n.number().int().min(1).default(1),
	startDate: n.iso.datetime(),
	endDate: n.iso.datetime().optional(),
	maxOccurrences: n.number().int().min(1).optional(),
	dayOfMonth: n.number().int().min(1).max(31).optional(),
	isLastDayOfMonth: n.boolean().default(!1),
	daysOfWeek: n.array(n.number().int().min(0).max(6)).default([]),
	monthOfYear: n.number().int().min(1).max(12).optional()
}, Y = q.extend({
	...J,
	type: n.literal("BUSINESS"),
	category: H,
	lineItemId: n.string().nullable().optional()
}), X = q.extend({
	...J,
	type: n.literal("REIMBURSEMENT"),
	clientId: n.string().min(1)
});
n.discriminatedUnion("type", [Y, X]);
var Me = Y.partial().extend({ type: n.literal("BUSINESS") }), Ne = X.partial().extend({ type: n.literal("REIMBURSEMENT") });
n.discriminatedUnion("type", [Me, Ne]), n.object({
	id: n.string(),
	rexpNumber: n.number(),
	status: K,
	type: B,
	category: H.nullable(),
	title: n.string(),
	clientId: n.string().nullable(),
	clientName: n.string().nullable(),
	lineItemId: n.string().nullable(),
	totalCost: n.number(),
	taxIncluded: n.boolean(),
	taxType: j,
	taxRate: n.number(),
	claimableAmount: n.number(),
	claimableAmountType: V,
	description: n.string().nullable(),
	frequency: I,
	interval: n.number(),
	dayOfMonth: n.number().nullable(),
	isLastDayOfMonth: n.boolean(),
	daysOfWeek: n.array(n.number()),
	monthOfYear: n.number().nullable(),
	startDate: n.iso.datetime(),
	endDate: n.iso.datetime().nullable(),
	maxOccurrences: n.number().nullable(),
	occurrenceCount: n.number(),
	nextRunAt: n.iso.datetime().nullable(),
	lastRunAt: n.iso.datetime().nullable(),
	createdAt: n.iso.datetime(),
	updatedAt: n.iso.datetime()
}), n.object({
	id: n.string(),
	recurringExpenseId: n.string(),
	scheduledFor: n.iso.datetime(),
	status: je,
	attemptCount: n.number(),
	triggeredBy: n.string(),
	startedAt: n.iso.datetime(),
	completedAt: n.iso.datetime().nullable(),
	nextRetryAt: n.iso.datetime().nullable(),
	expenseId: n.string().nullable(),
	errorCode: n.string().nullable(),
	errorMessage: n.string().nullable()
}), n.object({
	status: K.optional(),
	type: B.optional()
});
//#endregion
//#region ../shared/dist/quotes.js
var Pe = n.enum([
	"DRAFT",
	"SENT",
	"ACCEPTED",
	"DECLINED",
	"EXPIRED",
	"SUPERSEDED",
	"INVOICED"
]), Z = n.object({
	clientId: n.string().min(1, { error: "You must select a client from the list" }),
	notes: h,
	terms: h,
	taxType: M.default("NONE"),
	taxRate: n.coerce.number().min(0, { error: "Tax rate cannot be negative" }).max(1, { error: "Tax rate cannot exceed 100%" }).default(0),
	discount: n.coerce.number().min(0, { error: "Discount cannot be negative" }).default(0),
	discountType: x.default("NONE"),
	expiresAt: n.string().optional().transform(m).pipe(n.iso.datetime().optional()),
	lineItems: n.array(n.union([k, A])).optional()
});
Z.refine(S, C), Z.partial().refine(S, C);
var Q = n.object({
	lineItemId: h,
	title: n.string().min(1, { error: "Title must contain at least 1 character" }).max(255),
	description: h,
	unitPrice: n.coerce.number({ error: "Unit price must be a number" }).min(0, { error: "Unit price must be greater than or equal to 0" }),
	unitType: T.default("HOUR"),
	quantity: n.coerce.number().positive(),
	discount: n.coerce.number().min(0).default(0),
	discountType: E.default("NONE"),
	taxable: n.boolean().default(!0)
});
Q.refine(S, C), Q.partial().refine(S, C);
var Fe = n.object({
	id: n.string().optional(),
	lineItemId: n.string().optional(),
	title: n.string().min(1, { error: "Title must contain at least 1 character" }).max(255),
	description: n.string().optional(),
	unitPrice: n.coerce.number({ error: "Unit price must be a number" }).min(0, { error: "Unit price must be greater than or equal to 0" }),
	unitType: T.default("HOUR"),
	quantity: n.coerce.number().positive(),
	discount: n.coerce.number().min(0).default(0),
	discountType: E.default("NONE"),
	taxable: n.boolean().default(!0)
}).refine(S, C);
n.object({ lineItems: n.array(Fe) }), n.object({
	invoiceDate: n.iso.datetime(),
	dueDate: n.iso.datetime(),
	remindersEnabled: n.boolean().optional(),
	reminderScheduleId: n.string().min(1).nullable().optional()
});
var Ie = n.object({
	label: n.string().min(1).max(120),
	issueDate: n.iso.datetime(),
	dueDate: n.iso.datetime(),
	percentage: n.number().int().min(1).max(99).optional(),
	lineItemAllocations: n.array(n.object({
		quoteLineItemId: n.string(),
		quantity: n.coerce.number().positive()
	})).min(1).optional()
});
n.object({
	mode: n.enum(["PERCENTAGE", "LINE_ITEM"]),
	splits: n.array(Ie).min(2).max(5),
	remindersEnabled: n.boolean().optional(),
	reminderScheduleId: n.string().min(1).nullable().optional()
}).refine((e) => e.mode !== "PERCENTAGE" || e.splits.every((e) => e.percentage !== void 0), {
	message: "percentage is required for every split in PERCENTAGE mode",
	path: ["splits"]
}).refine((e) => e.mode !== "LINE_ITEM" || e.splits.every((e) => e.lineItemAllocations !== void 0), {
	message: "lineItemAllocations is required for every split in LINE_ITEM mode",
	path: ["splits"]
}), n.object({
	status: Pe,
	declineReason: h
}).refine((e) => e.status !== "DECLINED" || e.declineReason !== void 0, {
	message: "declineReason is required when status is DECLINED",
	path: ["declineReason"]
}), n.enum([
	"invoice-summary",
	"clients",
	"line-items",
	"revenue-timeline",
	"aging",
	"revenue-by-tag",
	"expenses",
	"tax",
	"bas-summary",
	"profit-and-loss",
	"aged-receivables"
]), n.object({
	name: n.string().min(1).max(100),
	body: n.string().min(1)
}).partial(), n.object({
	id: n.string(),
	name: n.string(),
	body: n.string(),
	isDefault: n.boolean(),
	createdAt: n.string(),
	updatedAt: n.string()
}), n.object({
	endpoint: n.url(),
	keys: n.object({
		p256dh: n.string().min(1),
		auth: n.string().min(1)
	})
});
//#endregion
//#region ../shared/dist/user-feedback.js
var $ = {
	ALPHA_TESTING: "ALPHA_TESTING",
	BUG: "BUG",
	FEATURE_REQUEST: "FEATURE_REQUEST",
	GENERAL: "GENERAL"
}, Le = n.enum(Object.values($)), Re = n.enum(Object.values({
	CREATE_ACCOUNT: "CREATE_ACCOUNT",
	CREATE_CLIENTS: "CREATE_CLIENTS",
	CREATE_LINE_ITEMS: "CREATE_LINE_ITEMS",
	CREATE_QUOTES: "CREATE_QUOTES",
	CONVERT_QUOTE_TO_INVOICE: "CONVERT_QUOTE_TO_INVOICE",
	CREATE_INVOICES: "CREATE_INVOICES",
	CREATE_EXPENSES: "CREATE_EXPENSES",
	OTHER: "OTHER"
}));
n.object({
	rating: n.coerce.number().int().min(1).max(5),
	category: Le,
	goal: Re.optional(),
	taskCompleted: n.enum(["true", "false"]).optional().transform((e) => e === void 0 ? void 0 : e === "true"),
	primaryDetail: n.string().optional(),
	secondaryDetail: n.string().optional(),
	additionalThoughts: n.string().optional(),
	ratingReason: n.string().optional(),
	pageUrl: n.string()
}).superRefine((e, t) => {
	let n = e.category === $.ALPHA_TESTING;
	n && e.goal === void 0 && t.addIssue({
		code: "custom",
		message: "Goal is required for alpha testing feedback",
		path: ["goal"]
	}), n && e.taskCompleted === void 0 && t.addIssue({
		code: "custom",
		message: "Please indicate whether you were able to complete the task",
		path: ["taskCompleted"]
	});
	let r = !n || e.taskCompleted === !1;
	r && v(e.primaryDetail) && t.addIssue({
		code: "custom",
		message: "This field is required",
		path: ["primaryDetail"]
	}), r && v(e.secondaryDetail) && t.addIssue({
		code: "custom",
		message: "This field is required",
		path: ["secondaryDetail"]
	});
});
//#endregion
export { d as a, ee as i, ne as n, re as o, te as r, v as t };

//# sourceMappingURL=dist-V_vBpdZH.js.map